import SubMenu from '../enums/subMenu'
import SubMenuRotas from '../enums/subMenuRotas';

export const getChaveMenu = tipo => {

    switch (tipo) {
        
        //Ofício por Situação

        case SubMenuRotas.LIXEIRA:
            return SubMenu.LIXEIRA;

        case SubMenuRotas.EM_EDICAO:
            return SubMenu.EM_EDICAO;

        case SubMenuRotas.EM_REVISAO:
            return SubMenu.EM_REVISAO;

        case SubMenuRotas.EM_CORRECAO:
            return SubMenu.EM_CORRECAO;

        case SubMenuRotas.EM_REVISAO_OFICIAL:
            return SubMenu.EM_REVISAO_OFICIAL;

        case SubMenuRotas.PARA_ASSINATURA:
            return SubMenu.PARA_ASSINATURA;

        case SubMenuRotas.PARA_ASSINATURA_PRESIDENTE:
            return SubMenu.PARA_ASSINATURA_PRESIDENTE;

        case SubMenuRotas.AGUARDANDO_RECEBIMENTO_PROCESSO_SEI:
            return SubMenu.AGUARDANDO_RECEBIMENTO_PROCESSO_SEI;

        case SubMenuRotas.PENDENTE_DE_RECIBO:
            return SubMenu.PENDENTE_DE_RECIBO;

        case SubMenuRotas.PARA_ENVIO_DE_OFICIO:
            return SubMenu.PARA_ENVIO_DE_OFICIO;

        //Ofícios Enviados

        case SubMenuRotas.ENTREGUES:
            return SubMenu.ENTREGUES;

        case SubMenuRotas.NAO_ENTREGUES:
            return SubMenu.NAO_ENTREGUES;

        case SubMenuRotas.COM_CERTIDAO:
            return SubMenu.COM_CERTIDAO;

        case SubMenuRotas.CERTIDAO_PARA_ASSINATURA:
            return SubMenu.CERTIDAO_PARA_ASSINATURA;

        case SubMenuRotas.PARA_JUNTADA:
            return SubMenu.PARA_JUNTADA;
            
        case SubMenuRotas.CONCLUIDOS:
            return SubMenu.CONCLUIDOS;

        //Protocolo de Ofícios para Envio

        case SubMenuRotas.PROTOCOLOS_PENDENTES_DE_ENVIO:
            return SubMenu.PROTOCOLOS_PENDENTES_DE_ENVIO;

        case SubMenuRotas.PROTOCOLOS_PENDENTES_DE_RECIBO:
            return SubMenu.PROTOCOLOS_PENDENTES_DE_RECIBO;

        case SubMenuRotas.PROTOCOLOS_PARA_CORRECAO_DE_RECIBO:
            return SubMenu.PROTOCOLOS_PARA_CORRECAO_DE_RECIBO;

        default:
            return null
    }
}